import { gql } from '@apollo/client'
import React from 'react'

import { generalClient } from '../../../utils/apollo/api'
import StatePresenter from '../../../components/helpers/StatePresenter'
import { usePaginatedQuery } from '../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../packages/kiti/components/helpers/LazyAction'

const Context = React.createContext([])
const { Provider } = Context
export const useProcessesState = () => React.useContext(Context)
export const useProcesses = () => useProcessesState()?.screens

const QUERY = gql`
  query Screens($filter: ScreenFilter, $page: Int) {
    screens(filter: $filter, page: $page, sort: { field: NAME, type: ASC }) {
      id
      name
      data
    }
  }
`

const ProcessesListLoader = ({ children }) => {
  const { data, fetchMore, ...state } = usePaginatedQuery(QUERY, {
    client: generalClient,
    fetchPolicy: 'cache-first',
    variables: {
      page: 1,
      filter: { screens: 'service_orders' }
    }
  })

  return (
    <StatePresenter {...state} empty={false}>
      <Provider value={data}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
      </Provider>
    </StatePresenter>
  )
}

export default ProcessesListLoader
